<template lang="pug">
yz-dialog(v-if="showDialog" v-model="showDialog" persistent scrollable width="440")
  yz-card
    yz-dialog-normal-header(title="Stock Return Skipped" @close="onCancel")
    yz-dialog-normal-content
      div.yz-regular-body-sm.text-neutral-700.mt-4 Stock return calculation cannot be performed for this item due to the change in base UOM.
      div.yz-regular-body-sm.text-neutral-500.mt-2 The item will be removed without returning stock. Please adjust the stock manually in the stock action page.
    yz-dialog-normal-actions(save-label="Delete Item" cancel-label="Cancel" save-action-color="danger" @save="onConfirm" @cancel="onCancel")
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
    },
  },
  computed: {
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    onCancel () {
      this.$emit('cancel')
      this.showDialog = false
    },
    onConfirm () {
      this.$emit('confirm')
      this.showDialog = false
    }
  },
}
</script>
